export default "__VITE_ASSET__DPSqbtqO__"